module.exports = __webpack_public_path__ + "static/media/03_CALCINHA_ASA_DELTA_04.3114a9d6.jpg";